import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './index';

// Typed wrappers per the RTK docs. Use these everywhere instead of the raw
// react-redux hooks so RootState typing flows through and thunk dispatches
// keep their return types.
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
